import React from 'react'
import { catagories, cloud, recentPost, social } from '../data/blog-data'
import { Link } from 'react-router-dom'

export default function BlogSidebar() {
  return (
    <>
    <div className="sidebar mt-4 mt-sm-0 pt-2 pt-sm-0">
        <div className="widget mb-4 pb-2">
            <div id="search2" className="widget-search mb-0">
                <form role="search" method="get" id="searchform" className="searchform">
                    <div>
                        <input type="text" className="border rounded" name="s" id="s" placeholder="Search Keywords..."/>
                        <input type="submit" id="searchsubmit" value="Search"/>
                    </div>
                </form>
            </div>
        </div>

        <div className="widget mb-4 pb-2">
            <h4 className="widget-title">Catagories</h4>
            <div className="p-4 mt-4 rounded shadow">
                <ul className="list-unstyled mb-0 catagory">
                    {catagories.map((item,index)=>{
                        return(
                            <li key={index}><Link to="#">{item.title}</Link> <span className="float-end">{item.value}</span></li>
                        )
                    })}
                </ul>
            </div>
        </div>

        <div className="widget mb-4 pb-2">
            <h4 className="widget-title">Recent Post</h4>
            <div className="p-4 mt-4 rounded shadow">
                {recentPost.map((item,index)=>{
                    return(
                        <div className="clearfix post-recent" key={index}>
                            <div className="post-recent-thumb float-start"> <Link to="#"> <img alt="img" src={item.image} className="img-fluid rounded"/></Link></div>
                            <div className="post-recent-content float-start"><Link to="#">{item.title}</Link><span className="text-muted mt-2">{item.date}</span></div>
                        </div>
                    )
                })}
            </div>
        </div>

        <div className="widget mb-4 pb-2">
            <h4 className="widget-title">Tags Cloud</h4>
            <div className="tagcloud p-4 mt-4 rounded shadow">
                {cloud.map((item,index)=>{
                    return(
                        <Link to="#" className="rounded" key={index}>{item}</Link>
                    )
                })}
            </div>
        </div>
        
        <div className="widget">
            <h4 className="widget-title">Follow us</h4>
            <ul className="list-unstyled social-icon social pt-4 px-4 pb-3 mt-4 rounded shadow mb-0">
                {social.map((item,index)=>{
                    return(
                        <li className="list-inline-item m-x-2" key={index}><Link to="#" className="rounded"><i className={item}></i></Link></li>
                    )
                })}
            </ul>
        </div>
    </div>
    </>
  )
}
